/**
 * Freezes the execution of the program for the specified amount of time.
 * ! On React Native, this is a blocking operation! Use with caution.
 * @param ms The amount of time to sleep in milliseconds.
 * @returns A promise that resolves after the specified amount of time.
 */
export default function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
